import { Injectable } from '@angular/core';
import { skySwitchDB } from '@app/core/db/skyswitch-db';
import { liveQuery } from 'dexie';
import { from, Observable } from 'rxjs';

import { LambdaLogDBModel } from '../models/lambda.model';

@Injectable({
  providedIn: 'root',
})
export class LambdaStorageService {
  public async insert(log: LambdaLogDBModel): Promise<void> {
    await skySwitchDB.lambdaLogs.add({
      ...log,
    });

    // If the log count > 10, delete the oldest entry
    const count = await skySwitchDB.lambdaLogs.count();
    if (count > 10) {
      const oldestLog = await skySwitchDB.lambdaLogs.orderBy('createdAt').first();
      if (oldestLog?.id) {
        await skySwitchDB.lambdaLogs.delete(oldestLog.id);
      }
    }
  }

  public liveQuery(filter?: (LambdaLogDBModel) => boolean): Observable<LambdaLogDBModel[]> {
    const dexieObservable = liveQuery(() => {
      let collection = skySwitchDB.lambdaLogs.orderBy('createdAt').reverse();

      if (filter) {
        collection = collection.filter((item) => filter(item));
      }

      return collection.toArray();
    });

    return from(dexieObservable);
  }

  public async drop(): Promise<void> {
    await skySwitchDB.resetLambdaLogs();
  }
}
